/// <reference path="../include.ts" />

namespace project_commons {

	import View = alm.view.View;
	import TweenCSS = alm.util.TweenCSS;
	import Easing = alm.math.Easing;

	export class HeaderLogo extends View<JQuery> {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor() {
			super(jQuery('#header-logo'));
			this.initialize();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		protected implInitialize(): JQuery {
			const view = this.getView();
			return view;
		}

		protected implReady(): void {
		}

		protected implFinalize(): void {
		}

		protected implShow(view: JQuery, useTransition: boolean): cmd.Command {
			return TweenCSS.fadeIn(view, useTransition ? 500 : 0, Easing.easeOutQuart, 'flex', false, false);
		}

		protected implHide(view: JQuery, useTransition: boolean): cmd.Command {
			return TweenCSS.fadeOut(view, useTransition ? 500 : 0, Easing.easeOutQuart, true, false, false);
		}
	}
}
